import { MessageAttachmentModel } from "./messageAttachmentModel";
import { MessageReceiverModel } from "./messageReceiverModel";

export interface MessageModel {
  messageID?: number;
  senderUserID?: number;
  senderLoginID?: number;
  senderName?: string;
  senderPhotoID?: number;
  senderRelationshipToPatient?: string;
  senderIsPatient?: boolean;
  archived?: boolean;
  
  dateSent?: Date;
  unread?: boolean;

  receivers?: Array<MessageReceiverModel>;
  plainTextMessage?: string;
  message?: string;
  attachmentsText?: string;
  attachments?: Array<MessageAttachmentModel>;
}
